import { useTheme, spacing } from "@repo/tokens";

export const useMenuDrawerStyles = () => {
  const { theme } = useTheme();

  return {
    container: {
      width: "100%",
      maxHeight: "100dvh",
      boxSizing: "border-box" as const,
      backgroundColor: "rgba(255, 255, 255, 0.65)",
      WebkitBackdropFilter: "blur(10px)",
      backdropFilter: "blur(10px)",
      border: `1px solid rgba(255, 255, 255, 0.5)`,
      boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.45)",
      paddingTop: "clamp(24px, 5vh, 40px)",
      paddingBottom: "max(16px, env(safe-area-inset-bottom, 0px))",
      paddingLeft: spacing[6],

      paddingRight: spacing[6],
      display: "flex",
      flexDirection: "column" as const,
      gap: "clamp(16px, 3vh, 32px)",
      color: theme.text.primary,
      overflow: "hidden",
    },

    listContainer: {
      display: "flex",
      flexDirection: "column" as const,
      flex: "1 1 auto",
      minHeight: 0,
      width: "100%",
      overflowY: "auto",
      overflowX: "hidden",
      WebkitOverflowScrolling: "touch",
    },

    menuButton: {
      width: "100%",
      minHeight: "clamp(44px, 8vh, 52px)",
      justifyContent: "flex-start",
      backgroundColor: "transparent",
      border: "none",
      borderRadius: 0,
      outline: "none",
      boxShadow: "none",
    },
    menuItemContent: {
      paddingVertical: spacing[3],
      paddingHorizontal: spacing[2],
    },

    menuLabelBase: {
      fontSize: theme.typography.title.medium.regular.fontSize,
      fontWeight: 500,
    },

    menuLabelActive: {
      fontSize: theme.typography.title.medium.regular.fontSize,
      fontWeight: 500,
      color: theme.action.primary.default,
    },

    menuLabelInactive: {
      fontSize: theme.typography.title.medium.regular.fontSize,
      fontWeight: 500,
      color: theme.text.primary,
    },

    divider: {
      marginTop: 6,
      marginBottom: 6,
      backgroundColor: theme.colors.neutral[70],
    },

    footerLink: {
      fontSize: 11,
      textDecoration: "underline",
      color: theme.text.secondary,
    },

    versionText: {
      fontSize: 10,
      opacity: 0.6,
      color: theme.text.secondary,
    },

    footerContainer: {
      marginTop: 0,
      marginBottom: 0,
    },

    footerSeparator: {
      fontSize: 11,
      color: theme.text.secondary,
    },

    closeButton: {
      flexShrink: 0,
      margin: "0 auto",
      width: spacing[12],
      height: spacing[12],
      borderRadius: "50%",
      backgroundColor: theme.colors.neutral[100],
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
    },

    closeButtonText: {
      fontSize: 28,
      fontWeight: "bold" as const,
      lineHeight: "28px",
      color: theme.text.primary,
    },
    drawerFooterContainer: {
      alignItems: "center" as const,
      flexShrink: 0,
    },
    drawerFooterLinksRow: {
      justifyContent: "center" as const,
    },
    drawerFooterText: {
      fontSize: 12,
      textDecoration: "underline",
      color: theme.text.secondary,
    },
    drawerFooterSeparator: {
      fontSize: 12,
      color: theme.text.secondary,
    },
    drawerFooterVersion: {
      fontSize: 11,
      opacity: 0.6,
      color: theme.text.secondary,
    },
    logoutText: {
      ...theme.typography.title.large.regular,
      fontWeight: 500,
      color: theme.text.primary,
      textAlign: "center" as const,
      lineHeight: theme.typography.title.large.regular.lineHeight ?? "1.35",
      marginBottom: 28,
      paddingLeft: spacing[2],
      paddingRight: spacing[2],
    },

    logoutModalBody: {
      position: "relative" as const,
      width: "100%",
      boxSizing: "border-box" as const,
      paddingLeft: spacing[6],
      paddingRight: spacing[6],
      paddingTop: spacing[1],
      paddingBottom: 28,
    },

    logoutModalClose: {
      position: "absolute" as const,
      right: spacing[8],
      zIndex: 1,
      padding: 30,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    logoutIconSection: {
      display: "flex",
      flexDirection: "column" as const,
      alignItems: "center" as const,
      paddingTop: 80,
      width: "100%",
    },

    logoutOutlineButton: {
      width: "100%",
      height: spacing[12],
      borderRadius: 9999,
      borderWidth: 1,
      borderStyle: "solid" as const,
      borderColor: theme.feedback.error,
      backgroundColor: theme.colors.background[50],
      display: "flex",
      justifyContent: "center" as const,
      alignItems: "center" as const,
      cursor: "pointer",
      boxSizing: "border-box" as const,
    },

    logoutOutlineButtonText: {
      ...theme.typography.title.medium.regular,
      color: theme.feedback.error,
      fontWeight: 500,
    },

    logoutCloseLink: {
      ...theme.typography.title.medium.regular,
      marginTop: spacing[5],
      color: theme.action.primary.default,
      fontWeight: 500,
      textAlign: "center" as const,
      cursor: "pointer",
    },

    overlayLogout: {
      justifyContent: "flex-end",
      alignItems: "center",
    },
  };
};
